import React, {Component} from 'react';
import playerImage from './images/dickbagger.png';
import collectibleImage from './images/dick.png';
import deadCollectibleImage from './images/dicksplatter.png';
import startButtonImage from './images/startbutton.png';
import MusicPlayer from './MusicPlayer';

import {
    keyEventCodes,
    updateSpeedMillis,
    playerImageHeight,
    playerImageWidth,
    startGameKeyCodes,
    initialSpawnRate,
    disableSpawning,
    inProductionMode,
} from './constants';
import {
    getNewPlayerPositionForKeyPress,
    processCollectibleSpawning,
    updateCollectible,
    getGroundHeightInPixels,
    updateDeadPosition,
    limitPlayerPositionToBoundaries,
    getPlayerStartPosition,
    getTimeMillis,
    splitCollectiblesToOptimiseUpdating,
    getCaughtCount,
    updatePlayerSpeed,
    logPerformance,
} from './utilities';
import {StartButton, Header, MenuWrapper, Ground, ScoreText} from './App.styles';

const renderMenu = onClick => (
    <>
        <MenuWrapper>
            <Header>BAG OF DICKS</Header>
            <StartButton {...{src: startButtonImage, onClick}} />
        </MenuWrapper>
    </>
);
// todo move these two
const renderGame = (collectibles, playerPosition, windowHeight, score) => (
    <>
        <MusicPlayer />
        <ScoreText>{`Dicks Bagged: ${score}`}</ScoreText>
        <img
            alt="player"
            {...{
                src: playerImage,
                style: {
                    position: 'fixed',
                    left: `${playerPosition}px`,
                    top: `${getGroundHeightInPixels(windowHeight) - playerImageHeight}px`,
                },
            }}
        />
        {collectibles
            .filter(collectible => !collectible.caught)
            .map(({positionX, positionY, dead}, key) => (
                <img
                    alt="collectible"
                    {...{
                        src: dead ? deadCollectibleImage : collectibleImage,
                        positionx: positionX,
                        positiony: positionY,
                        key,
                        style: {
                            position: 'fixed',
                            left: `${positionX}px`,
                            top: `${positionY}px`,
                        },
                    }}
                />
            ))}
        <Ground />
    </>
);

class App extends Component {
    initialState = {
        onMenu: true,
        spawnRate: initialSpawnRate,
        collectibles: [],
        collectiblesToBeRenderedButNotUpdated: [],
        score: 0,
    };

    state = {
        onMenu: true,
        playerPosition: getPlayerStartPosition(window.innerWidth, playerImageWidth),
        keysDown: {},
        windowWidth: 0,
        windowHeight: 0,
        playerSpeed: 0,
        ...this.initialState,
    };

    setKeyDownToValueIfNotAlreadySet = (keyDown, newValue) => {
        const keysDown = this.state.keysDown;
        const keyAlreadyInDesiredState = keysDown[keyDown] === newValue;

        if (keyAlreadyInDesiredState) {
            return;
        }

        keysDown[keyDown] = newValue;
        this.setState({keysDown});
    };

    updateWindowDimensions() {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        const windowSizeChanged =
            this.state.newWidth !== newWidth || this.state.windowHeight !== newHeight;

        let collectiblesToBeRenderedButNotUpdated = this.state
            .collectiblesToBeRenderedButNotUpdated;
        let playerPosition = this.state.playerPosition;
        if (windowSizeChanged) {
            collectiblesToBeRenderedButNotUpdated = updateDeadPosition(
                newHeight,
                collectiblesToBeRenderedButNotUpdated,
            );
            playerPosition = getPlayerStartPosition(newWidth, playerImageWidth);
        }
        this.setState({
            windowWidth: newWidth,
            windowHeight: newHeight,
            collectiblesToBeRenderedButNotUpdated,
            playerPosition,
        });
    }

    gameLoop = () => {
        const {
            playerPosition,
            keysDown,
            spawnRate,
            collectibles,
            windowWidth,
            windowHeight,
            updateTime,
            playerSpeed,
            score,
            collectiblesToBeRenderedButNotUpdated,
            accelerometerValue,
        } = this.state;
        if (!inProductionMode) {
            logPerformance(false, this.state);
        }

        let newPlayerSpeed = updatePlayerSpeed(keysDown, playerSpeed, accelerometerValue);

        let newPlayerPositionForKeyPress = getNewPlayerPositionForKeyPress(
            playerPosition,
            playerSpeed,
        );

        const newPlayerPosition = limitPlayerPositionToBoundaries(
            newPlayerPositionForKeyPress,
            windowWidth,
        );
        const playerCollidedWithBoundary = newPlayerPositionForKeyPress !== newPlayerPosition;
        if (playerCollidedWithBoundary) {
            newPlayerSpeed = 0;
        }

        const updatedCollectibles = collectibles.map(
            updateCollectible(newPlayerPosition, windowHeight),
        );

        let newScore = score + getCaughtCount(updatedCollectibles) - getCaughtCount(collectibles);

        const {
            collectiblesToBeRenderedButNotUpdated: updatedCollectiblesToBeRenderedButNotUpdated,
            collectiblesStillRequiringUpdate,
        } = splitCollectiblesToOptimiseUpdating(
            updatedCollectibles,
            collectiblesToBeRenderedButNotUpdated,
        );

        let {newSpawnRate, newCollectibles} = processCollectibleSpawning(
            spawnRate,
            windowWidth,
            windowHeight,
        );

        if (disableSpawning) {
            newCollectibles = [];
        }
        this.setState({
            playerPosition: newPlayerPosition,
            spawnRate: newSpawnRate,
            collectibles: [].concat(newCollectibles, collectiblesStillRequiringUpdate),
            collectiblesToBeRenderedButNotUpdated: updatedCollectiblesToBeRenderedButNotUpdated,
            updateTime: getTimeMillis(),
            oldUpdateTime: updateTime,
            score: newScore,
            playerSpeed: newPlayerSpeed,
        });
    };

    keyDownHandler = ({key}) => this.setKeyDownToValueIfNotAlreadySet(key, true);

    keyUpHandler = ({key}) => {
        if (this.state.onMenu && startGameKeyCodes.indexOf(key) >= 0) {
            this.startGame();
        } else {
            this.setKeyDownToValueIfNotAlreadySet(key, false);
        }
    };

    updateAccelerometerValue = event =>
        this.setState({
            accelerometerValue: event.beta,
        });

    handleBackButtonPress = () => {
        if (window.screen.orientation.type === 'portrait-primary') {
            clearInterval(this.interval);
            this.setState(this.initialState);
        }
    };

    componentDidMount = () => {
        document.addEventListener(keyEventCodes.keyDown, this.keyDownHandler);
        document.addEventListener(keyEventCodes.keyUp, this.keyUpHandler);
        window.addEventListener('resize', this.updateWindowDimensions.bind(this));

        this.updateWindowDimensions();

        window.addEventListener('deviceorientation', this.updateAccelerometerValue, true);
        window.addEventListener('orientationchange', this.handleBackButtonPress);
    };

    componentWillUnmount = () => {
        document.removeEventListener(keyEventCodes.keyDown, this.keyDownHandler);
        document.removeEventListener(keyEventCodes.keyUp, this.keyUpHandler);
        window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
        window.removeEventListener('deviceorientation', this.updateAccelerometerValue);
        window.removeEventListener('orientationchange', this.handleBackButtonPress);

        if (this.interval) {
            clearInterval(this.interval);
        }
    };

    startGame = () => {
        const isMobileDevice = !!this.state.accelerometerValue;
        if (isMobileDevice) {
            // this was only added to general availibility relatively recently - late 2018.
            // Support of the experimental mode for older browsers is worthwhile
            if (document.documentElement.requestFullscreen)
                document.documentElement.requestFullscreen();
            else if (document.documentElement.webkitRequestFullscreen)
                document.documentElement.webkitRequestFullscreen();
            else if (document.documentElement.mozRequestFullScreen)
                document.documentElement.mozRequestFullScreen();
            else if (document.documentElement.msRequestFullscreen)
                document.documentElement.msRequestFullscreen();
            window.screen.orientation.lock('landscape');
        }

        this.setState({onMenu: false});
        this.interval = setInterval(this.gameLoop, updateSpeedMillis);
    };

    render = () => (
        <>
            {this.state.onMenu
                ? renderMenu(this.startGame.bind(this))
                : renderGame(
                      [].concat(
                          this.state.collectibles,
                          this.state.collectiblesToBeRenderedButNotUpdated,
                      ),
                      this.state.playerPosition,
                      this.state.windowHeight,
                      this.state.score,
                  )}
        </>
    );
}
// todo make movement smooth
export default App;
